import { useMutation } from '@apollo/client';

import activateContractMutation from 'bundles/enterprise-admin-contracts/mutations/ActivateContract.graphql';
import createContractMutation from 'bundles/enterprise-admin-contracts/mutations/CreateContract.graphql';
import pauseContractMutation from 'bundles/enterprise-admin-contracts/mutations/PauseContract.graphql';
import provisionRenewalContractMutation from 'bundles/enterprise-admin-contracts/mutations/ProvisionRenewalContract.graphql';
import contractLimitsMutation from 'bundles/enterprise-admin-contracts/mutations/UpdateContractLimits.graphql';
import contractNameMutation from 'bundles/enterprise-admin-contracts/mutations/UpdateContractName.graphql';
import type {
  ActivateContractMutation,
  ActivateContractMutationVariables,
} from 'bundles/enterprise-admin-contracts/mutations/__generated__/ActivateContract';
import type {
  CreateContractMutation,
  CreateContractMutationVariables,
} from 'bundles/enterprise-admin-contracts/mutations/__generated__/CreateContract';
import type {
  PauseContractMutation,
  PauseContractMutationVariables,
} from 'bundles/enterprise-admin-contracts/mutations/__generated__/PauseContract';
import type {
  EnterpriseContract_ProvisionRenewalContractMutation as ProvisionRenewalContractMutation,
  EnterpriseContract_ProvisionRenewalContractMutationVariables as ProvisionRenewalContractMutationVariables,
} from 'bundles/enterprise-admin-contracts/mutations/__generated__/ProvisionRenewalContract';
import type {
  UpdateContractLimitsMutation,
  UpdateContractLimitsMutationVariables,
} from 'bundles/enterprise-admin-contracts/mutations/__generated__/UpdateContractLimits';
import type {
  UpdateContractNameMutation,
  UpdateContractNameMutationVariables,
} from 'bundles/enterprise-admin-contracts/mutations/__generated__/UpdateContractName';

export const useContractActivationMutation = () => {
  return useMutation<ActivateContractMutation, ActivateContractMutationVariables>(activateContractMutation, {
    context: { clientName: 'gatewayGql' },
  });
};

export const useContractCreationMutation = () => {
  return useMutation<CreateContractMutation, CreateContractMutationVariables>(createContractMutation, {
    context: { clientName: 'gatewayGql' },
  });
};

export const useContractPauseMutation = () => {
  return useMutation<PauseContractMutation, PauseContractMutationVariables>(pauseContractMutation, {
    context: { clientName: 'gatewayGql' },
  });
};

export const useContractNameMutation = () => {
  return useMutation<UpdateContractNameMutation, UpdateContractNameMutationVariables>(contractNameMutation, {
    context: { clientName: 'gatewayGql' },
  });
};

export const useContractLimitsMutation = () => {
  return useMutation<UpdateContractLimitsMutation, UpdateContractLimitsMutationVariables>(contractLimitsMutation, {
    context: { clientName: 'gatewayGql' },
  });
};

export const useProvisionRenewalContractMutation = () => {
  return useMutation<ProvisionRenewalContractMutation, ProvisionRenewalContractMutationVariables>(
    provisionRenewalContractMutation,
    {
      context: { clientName: 'gatewayGql' },
    }
  );
};
